export function getParams (state){
    return state.params
}

export function getB2cIntegrationOptions(state) {
    return state.b2cIntegrationOptions
}


// WEBPACK FOOTER //
// ./src/modules/subscribers/getters.js